import styled from 'styled-components';
import { UIBox } from '@/components/ui/Box';

export const StyledContainer = styled(UIBox)`
  align-items: start;
  flex-direction: column;
  width: 100%;
  padding: 24px;
`;
